// extracted by mini-css-extract-plugin
export default {"tooltip":"environment-entry_tooltip__M3hy7"};